import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This video contains the same imagery as the previous video but the sound has been changed. A recording from a forest in Europe has been inserted. This was done to demonstrate that our expectations of sounds might depend on the environment. Some would say this sound is more suitable to the sound that we might hear in the forest. The birds chirping is something to be expected in a forest, depending on where you are from. The perception of sound and noise is influenced by culture, making the approach to addressing noise in a public environment highly personal. It is a highly subjective topic, so careful consideration of these aspects is advised.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/02/29/principle/principle-2.mp4`,
            },
          },
          styles: {
            padding: "4% 7%",
          },
        },
      },
    },
  },
};

export default principle;
